require("./bootstrap");
require("./helpers");

(function () {
    var isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;

    if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        if (document.getElementsByClassName("main-content")[0]) {
            var mainpanel = document.querySelector(".main-content");
            var ps = new PerfectScrollbar(mainpanel);
        }
        // sidebar
        if (document.getElementsByClassName('sidenav')[0]) {
            var sidebar = document.querySelector('.sidenav');
            var ps1 = new PerfectScrollbar(sidebar);
          };

          if (document.getElementsByClassName('navbar-collapse')[0]) {
            var fixedplugin = document.querySelector('.navbar:not(.navbar-expand-lg) .navbar-collapse');
            var ps2 = new PerfectScrollbar(fixedplugin);
          };
        // end sidebar
    }
})();

//Sidebar
// Verify navbar blur on scroll
if (document.getElementById('navbarBlur')) {
    navbarBlurOnScroll('navbarBlur');
  }

//Set Sidebar Color
function sidebarColor(a) {
    var parent = document.querySelector(".nav-link.active");
    var color = a.getAttribute("data-color");

    if (parent.classList.contains('bg-gradient-primary')) {
      parent.classList.remove('bg-gradient-primary');
    }
    if (parent.classList.contains('bg-gradient-dark')) {
      parent.classList.remove('bg-gradient-dark');
    }
    if (parent.classList.contains('bg-gradient-info')) {
      parent.classList.remove('bg-gradient-info');
    }
    if (parent.classList.contains('bg-gradient-success')) {
      parent.classList.remove('bg-gradient-success');
    }
    if (parent.classList.contains('bg-gradient-warning')) {
      parent.classList.remove('bg-gradient-warning');
    }
    if (parent.classList.contains('bg-gradient-danger')) {
      parent.classList.remove('bg-gradient-danger');
    }
    parent.classList.add('bg-gradient-' + color);
  }

// Set Navbar Minimized
function navbarMinimize(el) {
    var sidenavShow = document.getElementsByClassName('g-sidenav-show')[0];

    if (!el.getAttribute("checked")) {
      sidenavShow.classList.remove('g-sidenav-pinned');
      sidenavShow.classList.add('g-sidenav-hidden');
      el.setAttribute("checked", "true");
    } else {
      sidenavShow.classList.remove('g-sidenav-hidden');
      sidenavShow.classList.add('g-sidenav-pinned');
      el.removeAttribute("checked");
    }
  }

// Toggle Sidenav
const iconNavbarSidenav = document.getElementById('iconNavbarSidenav');
const iconSidenav = document.getElementById('iconSidenav');
const sidenav = document.getElementById('sidenav-main');
let body = document.getElementsByTagName('body')[0];
let className = 'g-sidenav-pinned';

if (iconNavbarSidenav) {
  iconNavbarSidenav.addEventListener("click", toggleSidenav);
}

if (iconSidenav) {
  iconSidenav.addEventListener("click", toggleSidenav);
}

function toggleSidenav() {
  if (body.classList.contains(className)) {
    body.classList.remove(className);
    setTimeout(function() {
      sidenav.classList.remove('bg-white');
    }, 100);
    sidenav.classList.remove('bg-transparent');

  } else {
    body.classList.add(className);
    sidenav.classList.add('bg-white');
    sidenav.classList.remove('bg-transparent');
    iconSidenav.classList.remove('d-none');

  }
}

// Deactivate sidenav type buttons on resize and small screens
window.addEventListener("resize", sidenavTypeOnResize);
window.addEventListener("load", sidenavTypeOnResize);

function sidenavTypeOnResize() {
  let elements = document.querySelectorAll('[onclick="sidebarType(this)"]');
  if (window.innerWidth < 1200) {
    elements.forEach(function(el) {
      el.classList.add('disabled');
    });
  } else {
    elements.forEach(function(el) {
      el.classList.remove('disabled');
    });
  }
}
//EndSidebar

// Verify navbar blur on scroll
if (document.getElementById("navbarBlur")) {
    navbarBlurOnScroll("navbarBlur");
}

// initialization of Tooltips
var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
});

// Navbar blur on scroll
function navbarBlurOnScroll(id) {
    const navbar = document.getElementById(id);
    let navbarScrollActive = navbar
        ? navbar.getAttribute("data-scroll")
        : false;
    let scrollDistance = 5;
    let classes = ["blur", "shadow-blur", "left-auto"];
    let toggleClasses = ["shadow-none"];

    if (navbarScrollActive == "true") {
        window.onscroll = debounce(function () {
            if (window.scrollY > scrollDistance) {
                blurNavbar();
            } else {
                transparentNavbar();
            }
        }, 10);
    } else {
        window.onscroll = debounce(function () {
            transparentNavbar();
        }, 10);
    }

    var isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;

    if (isWindows) {
        var content = document.querySelector(".main-content");
        if (navbarScrollActive == "true") {
            content.addEventListener(
                "ps-scroll-y",
                debounce(function () {
                    if (content.scrollTop > scrollDistance) {
                        blurNavbar();
                    } else {
                        transparentNavbar();
                    }
                }, 10)
            );
        } else {
            content.addEventListener(
                "ps-scroll-y",
                debounce(function () {
                    transparentNavbar();
                }, 10)
            );
        }
    }

    function blurNavbar() {
        navbar.classList.add(...classes);
        navbar.classList.remove(...toggleClasses);

        toggleNavLinksColor("blur");
    }

    function transparentNavbar() {
        navbar.classList.remove(...classes);
        navbar.classList.add(...toggleClasses);

        toggleNavLinksColor("transparent");
    }

    function toggleNavLinksColor(type) {
        let navLinks = document.querySelectorAll(".navbar-main .nav-link");
        let navLinksToggler = document.querySelectorAll(
            ".navbar-main .sidenav-toggler-line"
        );

        if (type === "blur") {
            navLinks.forEach((element) => {
                element.classList.remove("text-body");
            });

            navLinksToggler.forEach((element) => {
                element.classList.add("bg-dark");
            });
        } else if (type === "transparent") {
            navLinks.forEach((element) => {
                element.classList.add("text-body");
            });

            navLinksToggler.forEach((element) => {
                element.classList.remove("bg-dark");
            });
        }
    }
}

// Debounce Function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// initialization of Toasts
document.addEventListener("DOMContentLoaded", function () {
    var toastElList = [].slice.call(document.querySelectorAll(".toast"));

    var toastList = toastElList.map(function (toastEl) {
        return new bootstrap.Toast(toastEl);
    });

    var toastButtonList = [].slice.call(
        document.querySelectorAll(".toast-btn")
    );

    toastButtonList.map(function (toastButtonEl) {
        toastButtonEl.addEventListener("click", function () {
            var toastToTrigger = document.getElementById(
                toastButtonEl.dataset.target
            );

            if (toastToTrigger) {
                var toast = bootstrap.Toast.getInstance(toastToTrigger);
                toast.show();
            }
        });
    });
});

// Tabs navigation

var total = document.querySelectorAll(".nav-pills");

function initNavs() {
    total.forEach(function (item, i) {
        var moving_div = document.createElement("div");
        var first_li = item.querySelector("li:first-child .nav-link");
        var tab = first_li.cloneNode();
        tab.innerHTML = "-";

        moving_div.classList.add("moving-tab", "position-absolute", "nav-link");
        moving_div.appendChild(tab);
        item.appendChild(moving_div);

        var list_length = item.getElementsByTagName("li").length;

        moving_div.style.padding = "0px";
        moving_div.style.width =
            item.querySelector("li:nth-child(1)").offsetWidth + "px";
        moving_div.style.transform = "translate3d(0px, 0px, 0px)";
        moving_div.style.transition = ".5s ease";

        item.onmouseover = function (event) {
            let target = getEventTarget(event);
            let li = target.closest("li"); // get reference
            if (li) {
                let nodes = Array.from(li.closest("ul").children); // get array
                let index = nodes.indexOf(li) + 1;
                item.querySelector(
                    "li:nth-child(" + index + ") .nav-link"
                ).onclick = function () {
                    moving_div = item.querySelector(".moving-tab");
                    let sum = 0;
                    if (item.classList.contains("flex-column")) {
                        for (var j = 1; j <= nodes.indexOf(li); j++) {
                            sum += item.querySelector(
                                "li:nth-child(" + j + ")"
                            ).offsetHeight;
                        }
                        moving_div.style.transform =
                            "translate3d(0px," + sum + "px, 0px)";
                        moving_div.style.height = item.querySelector(
                            "li:nth-child(" + j + ")"
                        ).offsetHeight;
                    } else {
                        for (var j = 1; j <= nodes.indexOf(li); j++) {
                            sum += item.querySelector(
                                "li:nth-child(" + j + ")"
                            ).offsetWidth;
                        }
                        moving_div.style.transform =
                            "translate3d(" + sum + "px, 0px, 0px)";
                        moving_div.style.width =
                            item.querySelector("li:nth-child(" + index + ")")
                                .offsetWidth + "px";
                    }
                };
            }
        };
    });
}

setTimeout(function () {
    initNavs();
}, 100);

// Tabs navigation resize

window.addEventListener("resize", function (event) {
    total.forEach(function (item, i) {
        item.querySelector(".moving-tab").remove();
        var moving_div = document.createElement("div");
        var tab = item.querySelector(".nav-link.active").cloneNode();
        tab.innerHTML = "-";

        moving_div.classList.add("moving-tab", "position-absolute", "nav-link");
        moving_div.appendChild(tab);

        item.appendChild(moving_div);

        moving_div.style.padding = "0px";
        moving_div.style.transition = ".5s ease";

        let li = item.querySelector(".nav-link.active").parentElement;

        if (li) {
            let nodes = Array.from(li.closest("ul").children); // get array
            let index = nodes.indexOf(li) + 1;

            let sum = 0;
            if (item.classList.contains("flex-column")) {
                for (var j = 1; j <= nodes.indexOf(li); j++) {
                    sum += item.querySelector(
                        "li:nth-child(" + j + ")"
                    ).offsetHeight;
                }
                moving_div.style.transform =
                    "translate3d(0px," + sum + "px, 0px)";
                moving_div.style.width =
                    item.querySelector("li:nth-child(" + index + ")")
                        .offsetWidth + "px";
                moving_div.style.height = item.querySelector(
                    "li:nth-child(" + j + ")"
                ).offsetHeight;
            } else {
                for (var j = 1; j <= nodes.indexOf(li); j++) {
                    sum += item.querySelector(
                        "li:nth-child(" + j + ")"
                    ).offsetWidth;
                }
                moving_div.style.transform =
                    "translate3d(" + sum + "px, 0px, 0px)";
                moving_div.style.width =
                    item.querySelector("li:nth-child(" + index + ")")
                        .offsetWidth + "px";
            }
        }
    });

    if (window.innerWidth < 991) {
        total.forEach(function (item, i) {
            if (!item.classList.contains("flex-column")) {
                item.classList.remove("flex-row");
                item.classList.add("flex-column", "on-resize");
                let li = item.querySelector(".nav-link.active").parentElement;
                let nodes = Array.from(li.closest("ul").children); // get array
                let index = nodes.indexOf(li) + 1;
                let sum = 0;
                for (var j = 1; j <= nodes.indexOf(li); j++) {
                    sum += item.querySelector(
                        "li:nth-child(" + j + ")"
                    ).offsetHeight;
                }
                var moving_div = document.querySelector(".moving-tab");
                moving_div.style.width =
                    item.querySelector("li:nth-child(1)").offsetWidth + "px";
                moving_div.style.transform =
                    "translate3d(0px," + sum + "px, 0px)";
            }
        });
    } else {
        total.forEach(function (item, i) {
            if (item.classList.contains("on-resize")) {
                item.classList.remove("flex-column", "on-resize");
                item.classList.add("flex-row");
                let li = item.querySelector(".nav-link.active").parentElement;
                let nodes = Array.from(li.closest("ul").children); // get array
                let index = nodes.indexOf(li) + 1;
                let sum = 0;
                for (var j = 1; j <= nodes.indexOf(li); j++) {
                    sum += item.querySelector(
                        "li:nth-child(" + j + ")"
                    ).offsetWidth;
                }
                var moving_div = document.querySelector(".moving-tab");
                moving_div.style.transform =
                    "translate3d(" + sum + "px, 0px, 0px)";
                moving_div.style.width =
                    item.querySelector("li:nth-child(" + index + ")")
                        .offsetWidth + "px";
            }
        });
    }
});

// Function to remove flex row on mobile devices
if (window.innerWidth < 991) {
    total.forEach(function (item, i) {
        if (item.classList.contains("flex-row")) {
            item.classList.remove("flex-row");
            item.classList.add("flex-column", "on-resize");
        }
    });
}

function getEventTarget(e) {
    e = e || window.event;
    return e.target || e.srcElement;
}

// End tabs navigation

window.onload = function () {
    // Material Design Input function
    var inputs = document.querySelectorAll("input");

    for (var i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener(
            "focus",
            function (e) {
                this.parentElement.classList.add("is-focused");
            },
            false
        );

        inputs[i].onkeyup = function (e) {
            if (this.value != "") {
                this.parentElement.classList.add("is-filled");
            } else {
                this.parentElement.classList.remove("is-filled");
            }
        };

        inputs[i].addEventListener(
            "focusout",
            function (e) {
                if (this.value != "") {
                    this.parentElement.classList.add("is-filled");
                }
                this.parentElement.classList.remove("is-focused");
            },
            false
        );
    }

    // Ripple Effect
    var ripples = document.querySelectorAll(".btn");

    for (var i = 0; i < ripples.length; i++) {
        ripples[i].addEventListener(
            "click",
            function (e) {
                var targetEl = e.target;
                var rippleDiv = targetEl.querySelector(".ripple");

                rippleDiv = document.createElement("span");
                rippleDiv.classList.add("ripple");
                rippleDiv.style.width = rippleDiv.style.height =
                    Math.max(targetEl.offsetWidth, targetEl.offsetHeight) +
                    "px";
                targetEl.appendChild(rippleDiv);

                rippleDiv.style.left =
                    e.offsetX - rippleDiv.offsetWidth / 2 + "px";
                rippleDiv.style.top =
                    e.offsetY - rippleDiv.offsetHeight / 2 + "px";
                rippleDiv.classList.add("ripple");
                setTimeout(function () {
                    rippleDiv.parentElement.removeChild(rippleDiv);
                }, 600);
            },
            false
        );
    }
};
